
import React from 'react';
import ShareButton from 'components/ShareButton';
import { useEffect } from 'react';
import client from '../utils/cms';
import { useParams } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


const Post = ({ version = "long", data  }) => {

    const [postData, setPostData] = React.useState(data || { title: '', short_description: '', long_description: '' });
    const { slug } = useParams();

    const shareMessage = `${postData.title}: ${window.location.href}`;

      const handleCopy = (e) => {
        e.preventDefault();
    };

    const handleSelect = (e) => {
        e.preventDefault(); // Prevent text selection
    };

    const replaceBoldTags = (text) => {
        if (!text) return '';
        // Replace <bold>...</bold> with a React <span> element with bold styling
        // Also replace <br>, <br/>, <br /> with React <br /> elements
        const boldSplit = text.split(/(<bold>.*?<\/bold>)/g);
        let result = [];
        boldSplit.forEach((part, i) => {
            let elements = [];
            // Split by <br>, <br/>, <br />
            const brSplit = part.split(/<br\s*\/?>(?![^<]*<\/bold>)/gi);
            brSplit.forEach((subPart, j) => {
                if (subPart.startsWith('<bold>') && subPart.endsWith('</bold>')) {
                    const content = subPart.replace(/<\/?bold>/g, '');
                    elements.push(<span key={`bold-${i}-${j}`} style={{ fontWeight: 'bold' }}>{content}</span>);
                } else {
                    elements.push(subPart);
                }
                // Add double <br /> after every split except the last
                if (j < brSplit.length - 1) {
                    elements.push(<br key={`br1-${i}-${j}`} />);
                    elements.push(<br key={`br2-${i}-${j}`} />);
                }
            });
            result = result.concat(elements);
        });
        return result;
    }


    useEffect(() => {
        if (version !== "short" && slug) {
            const posts = client.collection('posts');


            const fetchData = async () => {
                try {
                    const result = await posts.find({
                        filters: {
                            slug: { $eq: slug },
                        },
                        populate: 
                            {cover: {populate: 'media_file'}, thumbnail: { populate: '*'}}, 
                    });
                    setPostData(result.data[0]);
                } catch (error) {
                    console.error('Error fetching posts:', error);
                }
            }
            fetchData();
        };
    }, [version, slug]);

      const handleContextMenu = (e) => {
        e.preventDefault();
    };


    return(
        <>
        <div
            className="max-w-3xl mx-auto mb-6 px-2 sm:px-0 shadow-sm"
            style={{
                width: '100%',
                aspectRatio: '768 / 432',
                position: 'relative',
                overflow: 'hidden',
                background: '#f3f4f6'}}
        >
            {version !== "short" && postData?.cover?.media_file ? (
                <div className='absolute inset-0 w-full h-full'>
                    <video
                        src={postData?.cover?.media_file?.url}
                        {...(version !== "short" && { autoPlay: true })}
                        {...(version !== "short" && { loop : true })}
                        muted
                        playsInline
                        className="w-full h-full object-cover shadow z-10 absolute inset-0"
                        style={{ width: '100%', height: '100%' }}
                        onContextMenu={handleContextMenu}
                    >
                        Your browser does not support the video tag.
                    </video>
                </div>
            ) : (
                <img
                    src={postData?.thumbnail?.url}
                    alt={postData?.thumbnail?.alternativeText || 'story thumbnail'}
                    className="w-full h-full object-cover shadow z-10 absolute inset-0"
                    style={{ width: '100%', height: '100%' }}
                    onContextMenu={handleContextMenu}
                />
            )}
        <Skeleton baseColor="#f8cfe6ff" highlightColor="#f9e0eeff" className="w-full h-full object-cover shadow"  style={{ width: '100%', height: '100%', position: 'absolute', inset: 0, zIndex: 0 }} />

        </div>
        {/* Text */}
        <div className="max-w-3xl mx-auto mb-6 px-2 sm:px-0 text-justify" style={{ userSelect: 'none', cursor: 'default' }}>
            <h2 className="font-bold text-base sm:text-lg mb-2"  onCopy={handleCopy} onSelect={handleSelect}>
                {postData.title}
            </h2>
            <p className="mb-2 text-base text-left" onCopy={handleCopy} onSelect={handleSelect}>
                {version === "short" ? replaceBoldTags(postData.short_description) : replaceBoldTags(postData.long_description)}
            </p>
            {version === "short" &&
                <div className="flex w-full text-justify justify-left text-lg">  <p> ... </p> </div>}
            {version !== "short" &&
                <div className="mt-6">
                    <p className="sm:text-base mr-3 mb-0"> share if it turns you on:</p>
                    <div className="mt-2 bg-white inline-flex pl-1 pt-1 pb-1 opacity-90 rounded-sm">
                        <ShareButton social="whatsapp" shareMessage={shareMessage} />
                        <ShareButton social="instagram"  message={postData.title} insta_url={postData.instagram_url}  />
                    </div>
                </div>
            }
        </div>
        </>
    );
}

export default Post;